import {inject, bindable, customElement, containerless, PLATFORM, LogManager} from 'aurelia-framework';
import {I18N} from 'aurelia-i18n';
import {ContentService} from '../../../../services/content-service';
import {GroupService} from '../../../../services/group/group-service';
import {User, UserDetails} from '../../../../services/user-service';
import {GroupEventBus} from '../../../../broadcast/group-event-bus';
import {SelectEvent} from '../../../../broadcast/group-events';
import {CurrentGroup} from '../../../../services/group/current-group';
import {Subscription} from "aurelia-event-aggregator";

const logger = LogManager.getLogger('AccountViewHeader');

@containerless()
@inject(ContentService, GroupService, I18N, UserDetails, GroupEventBus, CurrentGroup)
@customElement('account-view-header')
export class AccountViewHeader {
  @bindable data;
  @bindable mode;

  userData: Partial<User>;
  title: string;
  userGroups: any;
  groupInvite: boolean;
  selectedGroup: number;
  private __selectionSubscription: Subscription;
  jsonData: any;
  myProfile: any;
  contactName: any;
  contactId: any;
  contactNickname: any;
  billing: any;
  disconnect: any;
  accept: any;
  invite: any;
  reinvite: any;
  viewTitle: string;

  constructor(private __contentService: ContentService, private __groupService: GroupService, private __i18n: I18N, userDetails: UserDetails, private __groupEventBus: GroupEventBus, private __currentGroup: CurrentGroup) {
    //set user info
    this.userData = userDetails.data;
    this.title = this.__i18n.tr('account.title');
    this.__groupService.rootList(false).response.then(data => {
      this.userGroups = data;
    }).catch((e) => {
      logger.error(e);
    });
    this.groupInvite = false;
  }

  bind() {
    this.__currentGroup.onReady().then(() => this.selectedGroup = this.__currentGroup.state.groupId);
    this.__selectionSubscription = this.__groupEventBus.subscribe(SelectEvent, msg => {
      this.selectedGroup = msg.groupId;
    }, this);
    if (this.data) {
      this.jsonData = JSON.parse(this.data);
      if (this.jsonData) {
        this.myProfile = (this.jsonData.contactId && this.jsonData.userId) ? (this.jsonData.userId == this.jsonData.contactId ? true : false) : null;
        this.contactName = this.jsonData.contactName;
        this.contactId = this.jsonData.contactId;
        this.contactNickname = this.jsonData.contactNickName;
        this.billing = this.jsonData.billing;
        this.disconnect = this.jsonData.disconnect;
        this.accept = this.jsonData.accept;
        this.invite = this.jsonData.invite;
        this.reinvite = this.jsonData.reinvite;
      }
    }
    if (!this.myProfile) {
      this.myProfile = this.mode == 'edit' || this.mode == 'billing' ? true : false;
    }
    this.setViewTitle();
  }

  unbind() {
    this.__selectionSubscription.dispose();
  }

  detached() {

  }

  editProfile() {
    this.__contentService.editUserProfile({
      groupId: this.selectedGroup
    });
  }

  viewProfile() {
    this.__contentService.showUser(this.userData.nickname, this.__currentGroup.state.groupId);
  }

  deactivateProfile() {
    this.__contentService.deactivateProfile();
  }

  contactConnect() {
    return new Promise(resolve => {
      PLATFORM.global.confirm(
        this.__i18n.tr('switchboard.connect_to_user'),
        this.__i18n.tr('switchboard.want_invite', {'contactName': this.contactName}),
        resolve
      );
    }).then(() => {
      this.__contentService.saveContactProperty('connect', this.jsonData.contactId).then(() => {
        this.__contentService.showUser(this.contactNickname, this.selectedGroup);
      }
      );
    });
  }

  // __connect(){
  //   this.__contentService.saveContactProperty("connect",this.jsonData.userId).then(() => {
  //     console.log('saved');
  //     this.__contentService.showUser(this.contactNickname)}
  //     );
  // }
  contactDisconnect() {
    return new Promise(resolve => {
      PLATFORM.global.confirm(
        this.__i18n.tr('switchboard.diconnect_user'),
        this.__i18n.tr('switchboard.user_disconnect_question', {'contactName': this.contactName}),
        resolve
      );
    }).then(() => {
      this.__contentService.saveContactProperty('disconnect', this.jsonData.contactId).then(() => {
        console.log('saved');
        this.__contentService.showUser(this.contactNickname);
      }
      );
    });
  }

  contactAccept() {
    return new Promise(resolve => {
      PLATFORM.global.confirm(
        this.__i18n.tr('switchboard.accept_request'),
        this.__i18n.tr('switchboard.accept_connection_question', {'contactName': this.contactName}),
        resolve
      );
    }).then(() => {
      this.__contentService.saveContactProperty('accept', this.jsonData.contactId).then(() => {
        console.log('saved');
        this.__contentService.showUser(this.contactNickname);
      }
      );
    });
  }

  contactReconnect() {
    return new Promise(resolve => {
      PLATFORM.global.confirm(
        this.__i18n.tr('switchboard.user_reinvite'),
        this.__i18n.tr('switchboard.resend_invite_question', {'contactName': this.contactName}),
        resolve
      );
    }).then(() => {
      this.__contentService.saveContactProperty('connect', this.jsonData.contactId).then(() => {
        console.log('saved');
        this.__contentService.showUser(this.contactNickname, this.selectedGroup);
      }
      );
    });
  }

  loadBilling() {
    this.__contentService.loadContent('billing/personalAccount/' + this.userData.id);
  }

  setViewTitle() {
    switch (this.mode) {
    case 'edit':
      this.viewTitle = this.__i18n.tr('account.editprofile');
      break;
    case 'billing':
      this.viewTitle = this.__i18n.tr('account.billing');
      break;
    case 'view':
      this.viewTitle = this.myProfile ? this.__i18n.tr('account.myprofile') : this.contactName;
      break;

    }
  }

  inviteToGroup() {
    this.groupInvite = !this.groupInvite;
    //this.__ea.publish('DSSB:invite-to-group');
  }
}
